
import React from 'react';
import { CheckCircle } from 'lucide-react';
import type { View } from '../types';

interface SuccessViewProps {
  setCurrentView: (view: View) => void;
}

const SuccessView: React.FC<SuccessViewProps> = ({ setCurrentView }) => {
  return (
    <div className="flex items-center justify-center min-h-[60vh] animate-fadeIn">
      <div className="glass-card rounded-xl p-12 text-center max-w-2xl">
        <div className="w-20 h-20 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="text-white" size={48} />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">XML Successfully Generated!</h2>
        <p className="text-gray-400 mb-8">
          Your ASYCUDA World XML file has been generated and downloaded. 
          The declaration has been added to your history.
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => setCurrentView('upload')}
            className="bg-gradient-to-r from-teal-600 to-blue-700 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-xl transition-all"
          >
            New Declaration
          </button>
          <button
            onClick={() => setCurrentView('history')}
            className="bg-gray-700 border-2 border-gray-600 text-gray-200 px-6 py-3 rounded-lg font-semibold hover:border-gray-500 hover:bg-gray-600 transition-all"
          >
            View History
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessView;
